import { toast } from "react-toastify";
import { COMMON, NOTIFICATION_SETTINGS } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

/** GET `Settings/NotificationSettings/metadata` */
export const fetchNotificationSettingsMetadata = async (data = {}) => {
  try {
    const response = await GET(NOTIFICATION_SETTINGS.METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Settings/NotificationSettings/filter` */
export const submitNotificationSettingsFilterData = async (data = {}) => {
  try {
    const response = await POST(NOTIFICATION_SETTINGS.FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `Settings/NotificationSettings/{id}` */
export const getNotificationSettingsById = async (id, data = {}) => {
  const raw = String(id ?? "").trim();
  if (!raw) {
    toast.error("Notification settings id is required");
    return undefined;
  }
  try {
    const response = await GET(NOTIFICATION_SETTINGS.BY_ID(raw), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Settings/NotificationSettings` */
export const createNotificationSettings = async (data = {}) => {
  try {
    const response = await POST(NOTIFICATION_SETTINGS.CREATE, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** PUT `Settings/NotificationSettings/{id}` */
export const updateNotificationSettings = async (id, data = {}) => {
  const raw = String(id ?? "").trim();
  if (!raw) {
    toast.error("Notification settings id is required");
    return undefined;
  }
  try {
    const response = await PUT(NOTIFICATION_SETTINGS.BY_ID(raw), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/notification-settings-for` — Settings For dropdown options. */
export const fetchNotificationSettingsForOptions = async () => {
  try {
    const response = await GET(COMMON.NOTIFICATION_SETTINGS_FOR);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
